<h2 *ngIf="data?.title">{{ data?.title }}</h2>

<p class="lead" [innerHTML]="data?.description"></p>
